import React from "react";
import RowBanner from "../../components/shared/row-banner/RowBanner";
import './StartExamRoute.scss';
import CurrentExam from '../../assest/images/exam/azmoonhayeJari.svg';
import FutureExam from '../../assest/images/exam/azmoonhayeAyandeh.svg';
import ComprehensiveExam from '../../assest/images/exam/azmooneJame.svg';
import RequestNewExam from "../../assest/images/exam/darkhasteAzmoon.svg";


export default class StartExamRoute extends React.PureComponent<{}, {}>{
    render(): React.ReactNode {
        return (<>
            <div className="dropdown-list  start-exam-route-area">
                <div className="col-12 col-md-12 tk-padding-top">
                    <div className="row" style={{ margin: "0" }}>
                        <div className="col-12 col-md-12  px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/CurrentExam", title: "آزمون‌های جاری", imageSource: CurrentExam }} />
                        </div>
                        <div className="col-12 col-md-12   px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/FutureExam", title: "آزمون‌های جامع", imageSource: FutureExam }} />
                        </div>
                        <div className="col-12 col-md-12  px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/ComprehensiveExam", title: "تعیین‌ سطح", imageSource: ComprehensiveExam }} />
                        </div>
                        <div className="col-12 col-md-12  px-0">
                            <RowBanner bannerDetail={{ redirectLink: "/RequestExamList", title: "درخواست آزمون", imageSource: RequestNewExam }} />
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}